import Loading from "components/Loading"

import { ComponentProps } from "."
import {
  Control,
  DisplayValue,
  Input,
  Label,
  OptionLi,
  OptionsUl,
  Triangle,
  Wrapper
} from "./styled"

const Select = ({
  className,
  defaultValue,
  displayValue,
  internalValue,
  isControlled,
  isLabelShrunk,
  isOpen,
  label,
  loading,
  name,
  onBlur,
  onChange,
  onToggleIsOpen,
  options,
  ref,
  required,
  value,
  wrapperRef
}: ComponentProps) => (
  <Wrapper className={className} onBlur={onBlur} ref={wrapperRef} tabIndex={-1}>
    <Control
      aria-expanded={isOpen}
      aria-haspopup="listbox"
      aria-labelledby={`${name}-label`}
      onClick={onToggleIsOpen}
      role="button"
    >
      <Label $isShrunk={isLabelShrunk} id={`${name}-label`}>
        {label}
      </Label>

      <DisplayValue
        $isSelected={Boolean((!isControlled && defaultValue) || value)}
      >
        {displayValue}
      </DisplayValue>

      {loading ? <Loading /> : <Triangle $isOpen={isOpen} />}
    </Control>

    {isOpen ? (
      <OptionsUl
        aria-labelledby={`${name}-label`}
        id={`${name}-listbox`}
        role="listbox"
      >
        {options.map((option, index) => (
          <OptionLi
            aria-selected={
              (!isControlled && option.value === defaultValue) ||
              option.value === value
            }
            id={`${name}-listbox-${index}`}
            key={option.value}
            onClick={onChange(option.value)}
            role="option"
          >
            {option.label}
          </OptionLi>
        ))}
      </OptionsUl>
    ) : null}

    <Input
      defaultValue={defaultValue}
      name={name}
      ref={ref}
      required={required}
      value={isControlled ? (value ?? undefined) : (internalValue ?? undefined)}
    />
  </Wrapper>
)

Select.displayName = "Select"

export default Select
